export const homeimagesarray = [
    require("./../assets/Landing Page/screenn.jpg"),
    require("./../assets/Landing Page/screennn.jpg"),
    require("./../assets/Landing Page/slide4.jpg")
]